const steps = [
  {
    num: "1",
    title: "Book a Free Call",
    desc: "Let's chat about your goals, your family's needs, and which path is right for you. No pressure, no sales pitch — just honest conversation.",
  },
  {
    num: "2",
    title: "Get Your Personalized Plan",
    desc: "I'll walk you through the system, answer all your questions, and create a customized roadmap for your family.",
  },
  {
    num: "3",
    title: "Launch & Learn",
    desc: "Join the members' club, start swapping products, and set up your simple automation tools. I'll be with you every step of the way.",
  },
  {
    num: "4",
    title: "Watch It Grow",
    desc: "As you share with your circle and they start shopping, you'll see the results: healthier home, extra income, and real freedom.",
  },
];

import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function JourneySection() {
  const { ref, visible } = useScrollReveal();

  return (
    <section id="journey" className="py-20 bg-olive-50">
      <div ref={ref} className={`mx-auto px-4 md:px-6 max-w-6xl transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-7'}`}>
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-olive-800 mb-3">
            Your Journey Starts Here
          </h2>
          <p className="text-olive-600">
            A simple 4-step process to transform your family's health and
            finances
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {steps.map((step, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 border border-olive-100 flex flex-col items-center text-center"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-olive-500 text-white font-bold rounded-full text-base mb-4">
                {step.num}
              </div>
              <h3 className="font-heading text-base font-bold text-olive-800 mb-2">
                {step.title}
              </h3>
              <p className="text-olive-600 text-sm leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
        <div className="text-center">
          <a
            href="https://calendly.com/carol-berry305"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-olive-500 hover:bg-olive-600 text-white font-semibold px-8 py-3.5 rounded-full text-base transition-all hover:scale-105 cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="fas fa-calendar-alt text-sm"></i>
            </span>
            Book Your Free Call Now
          </a>
        </div>
      </div>
    </section>
  );
}